<template>
  <div class="row">
    <div v-if="!load" class="col-md-12">
      <div
        v-if="items.length"
        id="nav-group"
        class="tab-pane fade show active pt-3"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <b-row>
          <b-col md="4" v-for="item in items" :key="item.id">
            <!--begin::Container-->
            <b-card no-body class="card-developer-meetup">
              <div class="bg-light-primary rounded-top text-center">
                <b-img :src="item.icon_path" alt="Meeting Pic" height="170" />
              </div>
              <b-card-body>
                <!-- metting header -->
                <div class="meetup-header d-flex align-items-center">
                  <div class="meetup-day">
                    <h3 class="mb-0">{{ item.code }}</h3>
                  </div>
                  <div class="my-auto">
                    <b-card-title class="mb-25">
                      {{ item.title }}
                    </b-card-title>
                    <b-card-text class="mb-0">
                      <b-badge variant="success" class="badge-glow">
                        <span v-if="item.language == 'ar'">عربي</span>
                        <span v-if="item.language == 'en'">english</span>
                        <span v-if="item.language == 'fr'">french</span>
                      </b-badge>
                      --
                      <b-badge variant="info" class="badge-glow">
                        {{ item.type.name }}
                      </b-badge>
                    </b-card-text>
                  </div>
                </div>
                <hr />
                <!--/ metting header -->

                <!-- media -->
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar rounded variant="light-primary" size="34">
                      <feather-icon icon="CalendarIcon" size="18" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">المواعيد المتاحة</h6>
                    <small> {{ item.quran_schedule_date_count }}</small>
                  </b-media-body>
                </b-media>
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar rounded variant="light-primary" size="34">
                      <feather-icon icon="TvIcon" size="18" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">نوع المقرأة</h6>
                    <small>
                      <b-badge variant="light-info" v-if="item.room_type == 0">
                        جماعي
                      </b-badge>
                      <b-badge variant="light-dark" v-else> فردي </b-badge>
                    </small>
                  </b-media-body>
                </b-media>
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar rounded variant="light-primary" size="34">
                      <feather-icon icon="ArrowUpIcon" size="18" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      {{ $t("quran_programs.max_students") }}
                    </h6>

                    <small>
                      <b-badge variant="light-primary">
                        <span v-if="item.max_students == -1"
                          >{{ $t("quran_programs.unlimited") }} </span
                        ><span> {{ item.max_students }} </span>
                      </b-badge>
                    </small>
                  </b-media-body>
                </b-media>
                <b-media no-body>
                  <b-media-aside class="mr-1">
                    <b-avatar rounded variant="light-primary" size="34">
                      <feather-icon icon="WatchIcon" size="18" />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">{{ $t("quran_programs.period") }}</h6>
                    <small> {{ item.period }}</small>
                  </b-media-body>
                </b-media>

                <hr />
                <b-row>
                  <b-col lg="12" class="text-center">
                    <b-button
                      :to="{
                        name: 'QuranProgramSchedules',
                        params: { id: item.id },
                      }"
                    >
                      المواعيد المتاحة
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <!-- /.tab-pane -->
      <div
        v-else
        id="nav-group"
        class="tab-pane fade show active pt-3"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <h2>لا توجد مقارئ متاحة الآن</h2>
      </div>
      <!-- /.tab-pane -->
    </div>
    <b-spinner v-else type="grow" label="Loading..." class="loading" />
  </div>
</template>

<script>
import QuranProgramsController from "@/Controllers/QuranProgramsController";
export default {
  name: "QuranProgramsٍtudent",

  data() {
    return {
      items: [],
      tab: 0,
      load: false,
      sideImg: require("@/assets/images/pages/buldozer.png"),
    };
  },
  async created() {
    this.load = true;
    let items = await new QuranProgramsController().GetAll({
      filter: "systemic|0",
      new: 1,
      withCount: ["quranScheduleDate"],
      with: ["type"],
    });
    this.items = items;
    this.load = false;
  },
  methods: {},
};
</script>
